<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">Terms of Service</span>
    </div>
    <div class="a-body flex-grow-1 overflow-y-auto p-20-px">
      <article class="tos-doc">
        <template v-for="(block, index) in blocks">
          <h1
            v-if="block.type === 'title'"
            :key="'t' + index"
            class="tos-doc__title"
          >
            {{ block.text }}
          </h1>
          <h2
            v-else-if="block.type === 'heading'"
            :key="'h' + index"
            class="tos-doc__heading"
          >
            {{ block.text }}
          </h2>
          <p
            v-else
            :key="'p' + index"
            class="tos-doc__p"
            :class="'tos-doc__p--indent-' + (block.indent || 0)"
          >
            <span
              v-for="(segment, sIndex) in segments(block.text)"
              :key="'s' + index + '-' + sIndex"
              :class="{ 'tos-doc__u': segment.underline }"
            >
              <span v-for="(part, pIndex) in linkify(segment.text)" :key="'l' + index + '-' + sIndex + '-' + pIndex">
                <a
                  v-if="part.href"
                  :href="part.href"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{ part.text }}</a>
                <template v-else>{{ part.text }}</template>
              </span>
            </span>
          </p>
        </template>
      </article>
    </div>
  </div>
</template>

<script>
  import { TERMS_OF_SERVICE_BLOCKS } from '../consts/termsOfService';

  const LINK_RE = /(https?:\/\/[^\s]+)|([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g;
  // Words underlined in the source PDF are wrapped in <u>...</u> in the constants; the marker is
  // consumed here and rendered as a styled span, never injected as HTML.
  const UNDERLINE_RE = /<u>([\s\S]*?)<\/u>/g;

  function trimTrailingPunctuation(value) {
    return value.replace(/[.,;:]+$/, '');
  }

  export default {
    name: 'TermsOfService',
    data() {
      return {
        blocks: TERMS_OF_SERVICE_BLOCKS,
      };
    },
    methods: {
      segments(text) {
        const segments = [];
        let lastIndex = 0;
        UNDERLINE_RE.lastIndex = 0;
        let match;
        while ((match = UNDERLINE_RE.exec(text))) {
          if (match.index > lastIndex) {
            segments.push({ text: text.slice(lastIndex, match.index), underline: false });
          }
          segments.push({ text: match[1], underline: true });
          lastIndex = match.index + match[0].length;
        }
        if (lastIndex < text.length) {
          segments.push({ text: text.slice(lastIndex), underline: false });
        }
        return segments;
      },
      linkify(text) {
        const parts = [];
        let lastIndex = 0;
        LINK_RE.lastIndex = 0;
        let match;
        while ((match = LINK_RE.exec(text))) {
          if (match.index > lastIndex) {
            parts.push({ text: text.slice(lastIndex, match.index) });
          }
          const raw = match[0];
          const trimmed = trimTrailingPunctuation(raw);
          const trailing = raw.slice(trimmed.length);
          if (match[1]) {
            parts.push({ text: trimmed, href: trimmed });
          } else {
            parts.push({ text: trimmed, href: `mailto:${trimmed}` });
          }
          if (trailing) {
            parts.push({ text: trailing });
          }
          lastIndex = match.index + raw.length;
        }
        if (lastIndex < text.length) {
          parts.push({ text: text.slice(lastIndex) });
        }
        return parts;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tos-doc {
    max-width: 860px;
    margin: 0 auto;
    padding: 8px 12px 40px;
    color: $pr;
    line-height: 1.7;
  }

  .tos-doc__title {
    margin: 0 0 20px;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.02em;
  }

  .tos-doc__heading {
    margin: 24px 0 8px;
    font-size: 15px;
    font-weight: 700;
  }

  .tos-doc__p {
    margin: 0 0 12px;
    font-size: 14px;
  }

  .tos-doc__p--indent-1 {
    padding-left: 12px;
  }

  .tos-doc__p--indent-2 {
    padding-left: 28px;
  }

  .tos-doc__u {
    text-decoration: underline;
  }

  .tos-doc a {
    color: $ace;
  }
</style>
